import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import './formCheckboxList.scss';

// import React, { Component } from 'react';

// import FormCheckableBox from '../@formCheckableBox/formCheckableBox';

import { services } from 'common';
const { Toast } = services;
import FormRadioboxList, { IProps as IBaseProps, IState as IBaseState } from '../@formRadioboxList/formRadioboxList';

import {
    ESectionValid,
    ESectionType,
    ISectionOptionBaseInfo,
    ISectionBaseExtend,
    ISectionBaseSetup,
    ISectionBaseInfo,
    ISectionBaseResult,
} from '@umu/umu-types';

interface IOptionState {
    [key: string]: boolean;
}

// tslint:disable-next-line:no-empty-interface
// tslint:disable-next-line: max-line-length
export interface IProps
    extends IBaseProps<ESectionType, ISectionOptionBaseInfo, ISectionBaseExtend<ISectionBaseSetup>> {}

export interface IState extends IBaseState {
    optionStateMap: IOptionState;
}

// 初始化选项选择状态map
function getInitOptionState(optionList: ISectionOptionBaseInfo[], userValue: string[] = []) {
    const ret: IOptionState = {};
    optionList.map((option) => {
        const key = option.id + '';
        ret[key] = userValue.indexOf(key) > -1;
    });
    return ret;
}

// 从 optionStateMap 中转换当前选中的值
function transformUserValue(optionStateMap: IOptionState) {
    const ret = [];
    for (const id in optionStateMap) {
        if (optionStateMap.hasOwnProperty(id) && optionStateMap[id]) {
            ret.push(id);
        }
    }
    return ret;
}

export default abstract class FormCheckboxList<IP extends IProps, IS extends IState> extends FormRadioboxList<IP, IS> {
    constructor(props: IP, state: IS) {
        super(props, state);

        this.listType = 'checkbox';

        const { userValue = [] } = props.sectionInfo;
        this.state = Object.assign({}, this.state, {
            optionStateMap: getInitOptionState(props.sectionInfo.list, userValue),
        });
    }

    public updateValue(userValueList: string[] = []) {
        const optionStateMap = this.state.optionStateMap;
        userValueList.forEach((id) => {
            const key = Number(id);
            if (typeof optionStateMap[key] !== 'undefined') {
                // @ts-ignore
                optionStateMap[key] = !optionStateMap[key];
            }
        });

        const userValue = transformUserValue(optionStateMap);
        const result = Object.assign({}, this.state.result, {
            userValue,
        });
        const isValid = this.validSection(this.props.sectionInfo, result);

        this.setState(
            {
                optionStateMap,
                result,
                isValid,
            },
            () => {
                this.props.onValueUpdate(this.getUserValue(), isValid);
            },
        );
    }

    // tslint:disable-next-line:max-line-length
    public abstract validSection(
        section: ISectionBaseInfo<any, ISectionOptionBaseInfo, ISectionBaseExtend<ISectionBaseSetup>>,
        result: ISectionBaseResult<any>,
    ): ESectionValid;

    public isValidBeforeOnChange(id: string) {
        const optionStateMap = this.state.optionStateMap;
        const key = Number(id);
        const isChecked = optionStateMap[key];

        const setup = this.props.sectionInfo.extend.setup;

        // 防止后端数据返回了数字
        const min = parseInt(setup.limit_options_min + '', 10);
        const max = parseInt(setup.limit_options_max + '', 10);
        if (!min || !max) {
            return true;
        }

        if (!isChecked && transformUserValue(optionStateMap).length >= max) {
            Toast.show({
                message: lang('至多{$0{0=个,1=个}}选项', max),
                duration: 1000,
            });
            return false;
        }

        return true;
    }

    public render() {
        return super.render();
    }

    public isOptionChecked = (itemId: number) => {
        const { optionStateMap } = this.state;
        return optionStateMap[itemId];
    };
}
